import { Star } from 'lucide-react';

const testimonials = [
  {
    quote:
      'LoadApp cut our dispatch time in half. We used to juggle spreadsheets and phone calls — now everything is in one place.',
    name: 'Mike Torres',
    role: 'Fleet Manager',
    company: 'Midwest Express Logistics',
  },
  {
    quote:
      "As an owner-operator, I needed something simple that didn't cost a fortune. LoadApp's free plan is perfect for my operation.",
    name: 'Sarah Chen',
    role: 'Owner-Operator',
    company: 'Chen Transport',
  },
  {
    quote:
      'The document vault alone is worth it. No more digging through email for BOLs. Everything is searchable and organized.',
    name: 'James Wright',
    role: 'Dispatcher',
    company: 'Atlantic Freight Co.',
  },
];

function QuoteMark() {
  return (
    <svg
      className="text-3xl mb-4"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="quoteGradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#2563EB" />
          <stop offset="100%" stopColor="#06B6D4" />
        </linearGradient>
      </defs>
      <text
        x="0"
        y="28"
        fontSize="40"
        fontFamily="Georgia, serif"
        fill="url(#quoteGradient)"
      >
        &ldquo;
      </text>
    </svg>
  );
}

function StarRating() {
  return (
    <div className="flex items-center gap-0.5 mb-4">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          className="w-4 h-4 text-yellow-400"
          fill="currentColor"
        />
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-6xl mx-auto px-6">
        {/* Eyebrow */}
        <p className="text-center text-blue-600 text-sm font-semibold uppercase tracking-widest mb-3">
          TESTIMONIALS
        </p>

        {/* Heading */}
        <h2 className="text-center text-4xl font-bold text-gray-900 mb-16">
          Trusted by Operators Nationwide
        </h2>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100"
            >
              <QuoteMark />
              <StarRating />
              <p className="text-gray-700 text-base italic leading-relaxed mb-4">
                &ldquo;{t.quote}&rdquo;
              </p>
              <p className="font-semibold text-gray-900 text-sm mt-4">
                {t.name}
              </p>
              <p className="text-gray-500 text-xs">
                {t.role}, {t.company}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
